<template>
  <b-container>
    <b-row>
      <b-col sm="12">
        <b-card class="chr-card-tour border-0 px-0">
          <b-card-header>
            <ResultHeader :result="result" />
          </b-card-header>
          <b-card-body class="p-0">
            <DACD :result="result" />
            <b-row class="mb-3">
              <b-col sm="3">
                <template v-if="result.images.length">
                  <img v-for="(image, imageIndex) in result.images" :src="image"
                    :key="'image' + imageIndex" class="img-thumbnail shadow-sm" />
                </template>
                <img v-else src="@/assets/images/default-image.jpg" class="img-thumbnail shadow-sm" />
              </b-col>
              <b-col sm="9">
                <b-row>
                  <b-col sm="12">
                    <p style="white-space: pre-line;" class="small">
                      {{ result.description }}
                    </p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <h6 class="border-0" v-translate>Departure dates</h6>
                    <b-card no-body class="border-top-0">
                      <Dates :result="result" />
                    </b-card>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="1">
                <h6 v-b-toggle="`included-${result.id} not-included-${result.id}`"><b-icon icon="caret-down-fill"/></h6>
              </b-col>
              <b-col sm="6">
                <h6 class="d-flex justify-content-between align-items-center px-2 font-weight-bolder"  v-b-toggle="`included-${result.id}`">
                  <span v-translate>Included</span>
                  <span><b-icon icon="caret-down-fill"/></span>
                </h6>
                <b-collapse :id="`included-${result.id}`" visible>
                  <b-card>
                    <p class="small" style="white-space: pre-line;">
                      {{ result.included }}
                    </p>
                  </b-card>
                </b-collapse>
              </b-col>
              <b-col sm="5">
                <h6 class="d-flex justify-content-between align-items-center px-2 font-weight-bolder" v-b-toggle="`not-included-${result.id}`">
                  <span v-translate>Not included</span>
                  <span><b-icon icon="caret-down-fill"/></span>
                </h6>
                <b-collapse :id="`not-included-${result.id}`" visible>
                  <b-card>
                    <p class="small" style="white-space: pre-line;">
                      {{ result.not_included }}
                    </p>
                  </b-card>
                </b-collapse>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="12" v-for="(dd, ddIndex) in result.detailed_descriptions" :key="'desc' + ddIndex">
        <h6 class="d-flex justify-content-between align-items-center px-2 font-weight-bolder">
          <span class="ml-2">{{ dd.label }}</span>
        </h6>
        <b-card class="border-0">
          <p class="small" v-html="dd.description">
          </p>
        </b-card>
      </b-col>
    </b-row>
    <b-row >

    </b-row>
  </b-container>
</template>

<script>
import ResultHeader from './result_header.vue'
import DACD from './dacd.vue'
import Dates from './dates.vue'

export default {
  name: 'Result',
  components: {
    ResultHeader,
    DACD,
    Dates
  },
  props: {
    result: {
      type: Object,
      mandatory: true
    },
    params: {
      type: Object,
      mandatory: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>
